import React from "react"

const CheckIcon = props => {
  return (
    <svg
      height='16'
      width='16'
      fill='none'
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.87163 8.24521L5.41725 6.8929L3.84616 8.41438L6.88061 11.2307L12.1539 6.28217L10.576 4.7692L6.87163 8.24521Z'
        fill='white'
      />
    </svg>
  )
}

export default CheckIcon
